// src/lib/uploadImageToBlob.js
import { upload } from '@vercel/blob/client';

export async function uploadImageToBlob(file, { folder = 'essays', onProgress, meta } = {}) {
  if (!file || !file.type?.startsWith('image/')) throw new Error('Arquivo inválido.');
  const MAX_BYTES = 2.5 * 1024 * 1024;
  if (file.size > MAX_BYTES) throw new Error('Imagem muito grande. Máximo 2,5MB.');

  const safe = file.name.replace(/[^\w.\-]/g, '_');
  const pathname = `${folder}/${Date.now()}-${safe}`;

  const result = await upload(pathname, file, {
    access: 'public',
    handleUploadUrl: '/api/blob/upload',      // must match the server route
    clientPayload: meta ? JSON.stringify(meta) : undefined,
    onUploadProgress: onProgress,
  });

  return { url: result.url, pathname: result.pathname, contentType: result.contentType, size: result.size };
}
